export const INVITE_USER_REQUEST = 'INVITE_USER_REQUEST'
export const INVITE_USER_RESET = 'INVITE_USER_RESET'
export const INVITE_USER_SUCCESS = 'INVITE_USER_SUCCESS'
export const INVITE_USER_ERROR = 'INVITE_USER_ERROR'
export const INVITE_USER_INVALID_EMAIL = 'INVITE_USER_INVALID_EMAIL'
